import { forOwn } from '../../../lib/utilities';
import API from '../../API/api';
import FilterOptionsConstants from '../../_flux/constants/filter_options_contants';

function requestConfiguratorOptions(filters, fieldsToBeFetched) {
    return API.POST({
        apiPath: '/configurator/home/',
        data: {
            filters,
            response: { fields: fieldsToBeFetched }
        },
        dataType: 'json'
    }).done(response => {
        forOwn(response, sizeOptions => {
            if (sizeOptions[0][FilterOptionsConstants.OPTION_VALUE] === '') {
                sizeOptions.shift();
            }
        });

        return response;
    });
}

export { requestConfiguratorOptions };
